import { actionTypes } from '../actionTypes';

export const onClickSidebarMenu = (activeMenu) => {
	return {
		type: actionTypes.sidebar.activeMenu,
		payload: activeMenu
	};
};
